import PropTypes from 'prop-types';
import React from 'react';


function Left({
  left,
  leftSize,
  leftProps
}: {
  left:React.ReactNode|string|undefined,
  leftSize: string|undefined,
  leftProps:any
}) {
  const { style, ...additionalProps } = leftProps;

  const basicStyle = {
    float: 'left',
    width: leftSize,
  };

  const leftStyle = style
    ? {
      ...style,
      ...basicStyle,
    }
    : basicStyle;

  return (
    <div style={leftStyle} {...additionalProps}>
      {left}
    </div>
  );
}

function Right({
  right,
  rightSize,
  rightProps
}:{
  right:React.ReactNode|string|undefined,
  rightSize: string|undefined,
  rightProps:any
}) {
  const { style, ...additionalProps } = rightProps;

  const basicStyle = {
    float: 'left',
    width: rightSize,
  };

  const rightStyle = style
    ? {
      ...style,
      ...basicStyle,
    }
    : basicStyle;

  return (
    <div style={rightStyle} {...additionalProps}>
      {right}
    </div>
  );
}

function LeftRightSplit({
  left,
  right,
  leftSize,
  rightSize,
  leftProps,
  rightProps
}:{
  left:React.ReactNode|string|undefined,
  leftSize: string|undefined,
  leftProps:any,
  right:React.ReactNode|string|undefined,
  rightSize: string|undefined,
  rightProps:any
}) {
  const containerStyle = { width: '100%', display: 'block' };

  return (
    <div style={containerStyle}>
      <Left left={left} leftSize={leftSize} leftProps={leftProps} />
      <Right right={right} rightSize={rightSize} rightProps={rightProps} />
      <div className="clearfix" />
    </div>
  );
}

LeftRightSplit.defaultProps = {
  leftSize: '50%',
  rightSize: '50%',
  leftProps: {},
  rightProps: {},
};

LeftRightSplit.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  leftSize: PropTypes.string.isRequired,
  rightSize: PropTypes.string.isRequired,
  leftProps: PropTypes.object.isRequired,
  rightProps: PropTypes.object.isRequired,
};


export default React.memo(LeftRightSplit);
